import React from 'react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { PRODUCT } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-14 text-center" data-id="element-173" data-mp="30h7m1qhd1wv3">
      <Reveal data-id="element-174" data-mp="2vq7msekrr2pf">
        <SectionHeading id="problema" title="¿Te pasa que querés leer la Biblia, pero terminás abandonando?" data-id="element-175" data-mp="2vppkb07ijs92" />
      </Reveal>

      <Reveal delay={0.05} className="mx-auto mt-8 max-w-2xl" data-id="element-176" data-mp="35gaor49vbqzw">
        <p className="font-display text-xl md:text-2xl font-bold uppercase leading-snug text-ink" data-id="element-177" data-mp="35g10pm8dvtwu">
          Muchas veces no faltan ganas. Falta una ruta.
        </p>
        <p className="mt-4 text-base md:text-lg leading-relaxed text-ink-muted" data-id="element-178" data-mp="3ei0iwhv4x41d">
          Abrís la Biblia, encontrás pasajes difíciles, no entendés el contexto
          y no sabés cómo aplicar lo que acabás de leer. Entonces postergás.
        </p>
        <p className="mt-6 font-script text-3xl md:text-4xl text-gold" data-id="element-179" data-mp="1k5anfvp4bmrv">
          “Algún día voy a aprender a entenderla mejor.”
        </p>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-ink-muted" data-id="element-180" data-mp="obeyl21yssb8">
          {PRODUCT} fue creado para ayudarte a empezar ahora, con una estructura
          clara y sencilla.
        </p>
      </Reveal>
    </section>;
}